module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translation-edit"
  }, [_c('div', {
    staticClass: "row column card pt-2"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.body.group) + "." + _vm._s(_vm.body.key))]), (_vm.allowedLanguages.length) ? [_vm._m(0), _vm._l((_vm.allowedLanguages), function(key) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column small-2 large-1 medium-1"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "readonly": "readOnly"
      },
      domProps: {
        "value": key
      }
    })]), _c('div', {
      staticClass: "column"
    }, [(_vm.editor) ? _c('Editor', {
      attrs: {
        "disabled": !_vm.item.editable && !_vm.editableKeys.includes(key)
      },
      model: {
        value: (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key]),
        callback: function($$v) {
          _vm.$set(typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value, key, $$v)
        },
        expression: "typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]"
      }
    }) : _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key]),
        expression: "typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]"
      }],
      attrs: {
        "name": key,
        "rows": "8",
        "disabled": !_vm.item.editable && !_vm.editableKeys.includes(key)
      },
      domProps: {
        "value": (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value, key, $event.target.value)
        }
      }
    })], 1)])
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.update
    }
  }, [_vm._v("Update")])], 1), _c('div', {
    staticClass: "column text-right"
  }, [(_vm.deleteButton) ? _c('TranslationButtons', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)])] : [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Missing allowedLanguages configuration")])]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("lang")])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("value")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-782b8b5e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TranslationEdit.vue
// module id = 2614
// module chunks = 1